import type { Foyer } from '@/engine/types';
import type { AuthUser } from '@/stores/auth-store';

/**
 * PRD §2.4, §6bis.3, §6bis.4 — `createdBy` rule.
 * Cloud mode stamps the authenticated user id; local mode is always null
 * because there is no user identity in local mode.
 */
export function resolveCreatedBy(
  foyer: Pick<Foyer, 'storageMode'>,
  user: AuthUser | null,
): string | null {
  if (foyer.storageMode !== 'cloud') return null;
  return user?.id ?? null;
}
